import { recordPath, recordRoute } from '@/shared/registry'

/** A person's transcript page. */
export const transcriptRoute = recordRoute('learner-history', 'transcripts')

/** The signed-in person's own transcript page. */
export const myTranscriptPath = '/learner-history/my-transcript'

/** A person's transcript. */
export function transcriptPath(learnerId: string): string {
  return recordPath('learner-history', 'transcripts', learnerId)
}

/** The permission the transcript needs. */
export const readLearnerRecordsPermission = 'learner-history.learner-records.read'

/**
 * The base of the transcript's slots (`detailsSlots`): its `panels` slot is the section slot other
 * features add whole sections to, such as Credentials' certificates.
 */
export const transcriptSlot = 'learner-history.transcript'

/** The action slot on each completion row, such as Credentials' certificate button; its context is the row's id. */
export const transcriptRowActionsSlot = 'learner-history.transcript.row-actions'

/** The API's transcript endpoints. */
export const myTranscriptApi = '/learner-history/v1/transcripts/me'

export function transcriptApi(learnerId: string): string {
  return `/learner-history/v1/transcripts/${encodeURIComponent(learnerId)}`
}
